module.exports = __webpack_public_path__ + "static/img/news.d7f550b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/news.jpg
// module id = Mqtb
// module chunks = 1